module.exports = __webpack_public_path__ + "img/heroBg.db7be133.webp";